import React from "react";
import { Box, ButtonBase, Popover } from "@mui/material";
import { CloseIcon } from "./Icon";

interface IClosablePopover {
  anchorEl: Element | null;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const ClosablePopover = ({
  anchorEl,
  open,
  onClose,
  children,
}: IClosablePopover) => (
  <Popover
    anchorEl={anchorEl}
    anchorOrigin={{
      vertical: "center",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "center",
      horizontal: "right",
    }}
    onClose={onClose}
    open={open}
  >
    <Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", px: 2, pt: 2 }}>
        <ButtonBase aria-label="close-popover" onClick={onClose}>
          <CloseIcon />
        </ButtonBase>
      </Box>
      {children}
    </Box>
  </Popover>
)